/*global _ */
import component from './component'
import form from './form'
import inputs from './inputs'
import page from './page'
import processing from './processing'

export default {
  component,
  form,
  inputs,
  page,
  processing
}
